import { Box, Button, SxProps, Theme, Typography } from "@mui/material"
import { btnCont, cardBtnImGoing, disabledCursorStyle, disabledStyle } from "./gradientBtnStyle"

type Props = {
  type?: string | "submit"
  title: string
  btnStyle?: SxProps<Theme>
  contStyle?: SxProps<Theme>
  textStyle?: SxProps<Theme>
  isShow?: boolean
  disabled?: boolean
  handleAction?: () => void
}

export default function GradientBtn({
  title,
  btnStyle,
  textStyle,
  contStyle,
  disabled,
  handleAction = () => {},
}: Props) {
  const combinedStyle = {
    ...cardBtnImGoing,
    ...btnStyle,
    ...(disabled ? disabledStyle : {})
  }
  const combConStyle = {
    ...btnCont,
    ...contStyle,
    ...(disabled ? disabledCursorStyle : {}),
  }

  return (
    <Box sx={combConStyle}>
      <Button  onClick={handleAction} sx={combinedStyle} disabled={disabled}>
        <Typography sx={textStyle}>{title}</Typography>
      </Button>
    </Box>
  )
}
